<template>
	<div class="survival-bonus">
		<HeadingSVG class="unfixed" imgName="survival-bonus" altText="Survival Bonus" />
		<div class="money-reward">
			+{{ survival_bonus | currency }}
		</div>
		<div class="wysiwyg-content desciption" v-html="survival_bonus_description" />
		<MarqueeButton :action="advance">{{ next_round_button_text }}</MarqueeButton>
	</div>
</template>

<script>
import HeadingSVG from "@/components/base/HeadingSVG";
import MarqueeButton from "@/components/base/MarqueeButton";

export default {
	name: 'SurvivalBonus',
	components: {
		HeadingSVG,
		MarqueeButton,
	},
	props: {
		next_round_button_text: {
			type: String,
			required: true,
		},
		survival_bonus: {
			type: Number,
			required: true,
		},
		survival_bonus_description: {
			type: String,
			required: true,
		},
	},
	methods: {
		advance() {
			this.$router.push("/game/rounds/complete");
			this.$store.dispatch("sound/fx/play", { id: "button_generic" });
		},
	},
	mounted() {
		this.$store.dispatch("sound/fx/play", { id: "survival_bonus" });
	},
};
</script>

<style lang="scss" scoped>
	.survival-bonus {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		margin: auto;
		max-width: 300px;
	}

	.heading.unfixed {
		width: 60%;
		margin-bottom: 0;

		@include tablet { width: 100%; }
	}

	.money-reward { margin-bottom: 10px; }
	.desciption { text-align: center; }
	.marquee-btn { margin-bottom: 0; }
</style>
